<template>
  <NuxtPage />
</template>

<script setup>
const { gtag } = useGtag()
onMounted(() => {
  const runtimeConfig = useRuntimeConfig()
  gtag('set', runtimeConfig.public.gtag.id, getGtagConfig())
})
</script>
